export default "/_next/static/chunks/fonts/Outfit ExtraBold-af2c70c8a67f488723d3e5915f5853fc.ttf";